__turbopack_context__.v({
  "backgroundAsset": "Hero-module-scss-module__UNGGWG__backgroundAsset",
  "content": "Hero-module-scss-module__UNGGWG__content",
  "ctaList": "Hero-module-scss-module__UNGGWG__ctaList",
  "headline": "Hero-module-scss-module__UNGGWG__headline",
  "hero": "Hero-module-scss-module__UNGGWG__hero",
  "heroContainer": "Hero-module-scss-module__UNGGWG__heroContainer",
  "mark-magenta": "Hero-module-scss-module__UNGGWG__mark-magenta",
  "mark-teal": "Hero-module-scss-module__UNGGWG__mark-teal",
  "stack-module-0": "Hero-module-scss-module__UNGGWG__stack-module-0",
  "stack-module-1": "Hero-module-scss-module__UNGGWG__stack-module-1",
  "stack-module-10": "Hero-module-scss-module__UNGGWG__stack-module-10",
  "stack-module-11": "Hero-module-scss-module__UNGGWG__stack-module-11",
  "stack-module-12": "Hero-module-scss-module__UNGGWG__stack-module-12",
  "stack-module-13": "Hero-module-scss-module__UNGGWG__stack-module-13",
  "stack-module-14": "Hero-module-scss-module__UNGGWG__stack-module-14",
  "stack-module-15": "Hero-module-scss-module__UNGGWG__stack-module-15",
  "stack-module-16": "Hero-module-scss-module__UNGGWG__stack-module-16",
  "stack-module-17": "Hero-module-scss-module__UNGGWG__stack-module-17",
  "stack-module-18": "Hero-module-scss-module__UNGGWG__stack-module-18",
  "stack-module-19": "Hero-module-scss-module__UNGGWG__stack-module-19",
  "stack-module-2": "Hero-module-scss-module__UNGGWG__stack-module-2",
  "stack-module-20": "Hero-module-scss-module__UNGGWG__stack-module-20",
  "stack-module-3": "Hero-module-scss-module__UNGGWG__stack-module-3",
  "stack-module-4": "Hero-module-scss-module__UNGGWG__stack-module-4",
  "stack-module-5": "Hero-module-scss-module__UNGGWG__stack-module-5",
  "stack-module-6": "Hero-module-scss-module__UNGGWG__stack-module-6",
  "stack-module-7": "Hero-module-scss-module__UNGGWG__stack-module-7",
  "stack-module-8": "Hero-module-scss-module__UNGGWG__stack-module-8",
  "stack-module-9": "Hero-module-scss-module__UNGGWG__stack-module-9",
  "z-base": "Hero-module-scss-module__UNGGWG__z-base",
  "z-content": "Hero-module-scss-module__UNGGWG__z-content",
  "z-footer": "Hero-module-scss-module__UNGGWG__z-footer",
  "z-header": "Hero-module-scss-module__UNGGWG__z-header",
  "z-hero": "Hero-module-scss-module__UNGGWG__z-hero",
  "z-logo": "Hero-module-scss-module__UNGGWG__z-logo",
  "z-logo-effect": "Hero-module-scss-module__UNGGWG__z-logo-effect",
  "z-navigation": "Hero-module-scss-module__UNGGWG__z-navigation",
  "z-sub": "Hero-module-scss-module__UNGGWG__z-sub",
});
